import {createReducer} from "typesafe-actions";
import update from "immutability-helper";
import {HtmlSignatureState} from "../types/htmlSignatures";
import {gotHTMLJson, gotHtmlSignatures} from "../actions/signatures";

const initialState: HtmlSignatureState = {
    total: 0,
};

export const htmlSignaturesReducer = createReducer(initialState)
    .handleAction(gotHtmlSignatures, (state, action) => update(state, {
        signatures: {$set: action.payload.items},
        total: {$set: action.payload.total},
    }))
    .handleAction(gotHTMLJson, (state, action) => update(state, {
        json: {$set: action.payload},
    }))
;
